import React from "react"
import { createBrowserHistory } from "history"
import { Router, Route } from "react-router-dom"

// All Routes
import Routes from "./Routes"

import "antd/dist/antd.css"

const history = createBrowserHistory()

class App extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<div className="App">
				<Router history={history}>
					<Routes />
				</Router>
			</div>
		)
	}
}

export default App
